module.exports = __webpack_public_path__ + "static/media/logo.66ed5558.svg";